module.exports = __webpack_public_path__ + "img/sms.ada25dff.svg";